import Glide from '@glidejs/glide';
import slider_responsiveness_breakpoints from '../../../src/js/slider-responsiveness.js';

document.addEventListener("DOMContentLoaded", code);
if( window.acf ) {
	window.acf.addAction( 'render_block_preview/type=our-clients', code );
}

function code(event) {
	try {
		let glide = new Glide('div[id^="block-our-clients-"] .glide', {
			type: 'carousel',
			perView: 4,
			gap: 215,
			breakpoints: slider_responsiveness_breakpoints()
		});
		
		glide.mount();
	} catch(error) {
		console.log('Error initializing Our Clients slider')
	}
}